<template>
  <div class="Dashbord" ref="document">
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="true"
        :is-full-page="fullPage"
        color="#018389"
        loader="dots"
      ></loading>
    </div>
    <!-- color="#fffff" -->
    <div class="Actions__Content" style="padding: 10px">
      <div class="DataTable">
        <div fluid style="padding-top: 10px; padding-bottom: 10px">
          <v-form ref="form">
            <v-layout
              row
              wrap
              style="padding-top: 0px !important; max-height: 1000px !important"
            >
              <v-flex
                xs7
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
              </v-flex>
              <v-flex
                xs4
                pa-2
                style="
                  padding-top: 0px !important;
                  padding-bottom: 0px !important;
                "
              >
              </v-flex>
              <v-flex
                xs1
                style="
                  text-align: center;
                  margin-bottom: 0px;
                  padding-left: 30px;
                "
              >
                <!-- <download-excel
                :data="json_data"
                :fields="json_fields"
                :meta="json_meta"
                :name="naziv_fajla"
                :param="json_fields"
              >
                <img
                  src="../assets/menuIcons/ico-print.png"
                  title="Štampa dokumenta"
                />
              </download-excel> -->

                <v-btn @click="stampaj" fab small
                  ><img
                    src="../assets/menuIcons/ico-print.png"
                    title="Štampa dokumenta"
                /></v-btn>
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout
            row
            wrap
            style="
              max-height: 100% !important;
              padding-top: 0px !important;
              padding-bottom: 0px !important;
            "
          >
            <v-flex
              xs12
              pa-2
              style="
                padding-top: 0px !important;
                padding-bottom: 0px !important;
              "
            >
              <v-data-table
                :headers="headers_states"
                :items="items_states"
                class="TankTable"
                item-key="tankPhaseWineId"
                ref="dTable"
                :pagination.sync="paginationKartica"
                :total-items="ukupnoRedova"
                :rows-per-page-items="listSize"
                style="padding-top: 10px"
                expand
                fixed-header
                hide-actions
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      style="padding-left: 5px; padding-right: 5px"
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        paginationKartica.descending ? 'desc' : 'asc',
                        header.value === paginationKartica.sortBy
                          ? 'active'
                          : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSortKartica(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.no }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ formatDateTime(props.item.date) }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.operation === "PRESSING" &&
                        props.item.pressingFraction !== null
                          ? prevediSveOperacijeLok(props.item.operation) +
                            " - " +
                            props.item.pressingFraction
                          : prevediSveOperacijeLok(props.item.operation)
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.tankFrom }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.tankTo }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        // props.item.operation === "CHANGE_WINE"
                        //   ? props.item.fromWine + (props.item.fromWineInProduction ? ' *' : '') + " > " + props.item.toWine + (props.item.toWineInProduction ? ' *' : '')
                        //   : props.item.wineAtMoment + (props.item.wineAtMomentInProduction ? ' *' : '')

                        props.item.wineAtMoment
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        // props.item.operation === "CHANGE_PHASE"
                        //   ? props.item.fromPhase + " > " + props.item.toPhase
                        //   : props.item.phaseAtMoment

                        props.item.phaseAtMoment
                      }}
                    </td>
                    <td
                      style="
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.additiveParameter !== null
                          ? props.item.additiveParameter
                          : "-"
                      }}
                    </td>
                    <td
                      style="
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        props.item.quantity !== null ? props.item.quantity + (props.item.operation === 'MACRO_OXYGENATION' || props.item.operation === 'MICRO_OXYGENATION' ? "(" + formatDateTime(props.item.date) + " - " + formatDateTime(props.item.oxygenationEndDate) + ")" : "" ) : "-"
                      }}
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
      </div>
    </div>
  </div>
</template>

        <script>
import { serverBus } from "../main";

import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import TokenComponent from "../components/Token";
import {
  readJSON,
  prevediOperacije3,
  prevediSveOperacije,
  getDateTime,
} from "../helpers/Functions";

import html2pdf from "html2pdf.js";

export default {
  props: ["naslov", "tpwId"],
  name: "Maka",
  dialog: false,
  components: {
    TokenComponent,

    Loading,
  },
  data() {
    return {
      isLoading: false,
      fullPage: true,

      headers_states: [
        { text: "Rb." },
        { text: "Datum", value: "date", align: "center", sortable: true },
        {
          text: "Operacija",
          value: "operation",
          align: "center",
          sortable: true,
        },
        {
          text: "Iz tanka",
          value: "room",
          align: "center",
          sortable: true,
        },
        {
          text: "U tank",
          value: "tank_name",
          align: "center",
          sortable: true,
        },
        {
          text: "Vino u tanku",
          value: "wine_at_moment",
          align: "center",
          sortable: true,
        },
        {
          text: "Faza",
          value: "phase_at_moment",
          align: "center",
          sortable: true,
        },
        {
          text: "Dodatak/Parametar",
          value: "additive",
          align: "center",
          sortable: true,
        },
        {
          text: "Količina",
          value: "quantity",
          align: "right",
          sortable: true,
        },
      ],
      items_states: [],
      listSize: [5, 10, 25, 50, 100, { text: "Svi", value: 1000000 }],
      paginationKartica: {
        sortBy: "wine_type_id",
        descending: true,
        rowsPerPage: 1000000,
        descending: true,
      },
      ukupnoRedova: 0,
      search: "",
      izabranaStranica: 0,
      loading: true,
      headers_modal: [
        {
          text: "Izabrani redovi",
          value: "tankNumberInBatch",
          align: "center",
        },
      ],
      headers_modal_sorta: [
        { text: "Izabrane sorte", value: "tankNumberInBatch", align: "center" },
      ],

      total: 0,

      json_fields_type: [],
      json_fields: {
        Rb: "String",
        "Sorta": "String",
        "Tip vina": "String",
        Količina: "Number",
      },
      kupovno_grozdje: false,
      items_kupovno_grozdje: [
        {
          id: 1,
          mark: "Sopstveno",
        },
        {
          id: 2,
          mark: "Kupovno",
        },
      ],
    };
  },
  computed: {
    params(nv) {
      return {
        ...this.paginationKartica,
        query: this.search,
      };
    },
  },
  watch: {
    naslov: function (val) {
      this.items_states = [];
    },
    tpwId: function (val) {
      this.items_states = [];

      if (val !== 0) this.getAllVina();
    },
  },

  methods: {
    prevediOperacije3lok(text) {
      return prevediOperacije3(text);
    },
    prevediSveOperacijeLok(tekst) {
      return prevediSveOperacije(tekst);
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");

      return `${day}.${month}.${year}`;
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join(".") + " " + [HH, mm].join(":");
      } else return "";
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    stampaj() {
      let _this = this;
      this.isLoading = true;

      setTimeout(() => {
        var elementToPrint = document.createElement("div");
        elementToPrint.style.margin = "0px 0px 0px 0px";

        var elementToPrint2 = document.createElement("p");
        elementToPrint2.innerHTML = _this.naslov;

        elementToPrint2.style.position = "relative";
        elementToPrint2.style.textAlign = "center";
        elementToPrint2.style.fontSize = "20px";
        elementToPrint.append(elementToPrint2);

        // var body = document.getElementsByTagName("body")[0];
        var tbl = document.createElement("table");
        var tr = document.createElement("tr"); // Header row
        jQuery.each(_this.json_fields, function (i, val) {
          var th = document.createElement("th"); //column
          var text = "";
          text = document.createTextNode(i);

          th.setAttribute("style", "padding-bottom: 4px;");

          th.appendChild(text);

          tr.appendChild(th);
        });

        tr.style.background = "#eaece5";
        tbl.appendChild(tr);

        var tblBody = document.createElement("tbody");

        let poslednjiRed = null;

        jQuery.each(_this.json_data, function (i, val1) {
          var row = document.createElement("tr");

          let pomJ = 0;

          jQuery.each(val1, function (i, val) {
            var cell = document.createElement("td");

            var cellText;

            if (val === null || val === 0 || val === "")
              cellText = document.createTextNode("-");
            else cellText = document.createTextNode(val);

            cell.appendChild(cellText);

            if (i === 1)
              cell.setAttribute(
                "style",
                "text-align :left; padding-left: 5px; padding-bottom: 4px;"
              );
            else if (
              _this.json_fields_type[pomJ] === "Number" ||
              _this.json_fields_type[pomJ] === "StringRight"
            ) {
              cell.setAttribute(
                "style",
                "text-align :right; padding-bottom: 4px; padding-right: 5px;"
              );
            } else if (_this.json_fields_type[pomJ] === "Date") {
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px; padding-right: 1px; padding-left: 1px;"
              );
            } else
              cell.setAttribute(
                "style",
                "text-align :center; padding-bottom: 4px;"
              );

            pomJ = pomJ + 1;

            row.appendChild(cell);
          });

          tblBody.appendChild(row);
        });

        tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        // tbl.style.borderColor = "black";

        tbl.appendChild(tblBody);

        tbl.style.margin = "0px 0px 0px 0px";
        tbl.style.width = "100%";

        elementToPrint.appendChild(tbl);

        var tbl = document.createElement("table");
        var tblBody = document.createElement("tbody");

        tbl.style.margin = "20px 0px 0px 75%";
        tbl.style.width = "25%";
        // tbl.setAttribute("border", "thin solid");
        tbl.style.borderCollapse = "collapse";
        tbl.appendChild(tblBody);
        elementToPrint.appendChild(tbl);

        // tbl.appendChild(tblBody);
        // elementToPrint.appendChild(tbl);

        // html2pdf(elementToPrint, {
        //   margin: 1,
        //   filename: item.number + ".pdf",
        //   image: { type: "jpeg", quality: 0.98 },
        //   // html2canvas: { dpi: 192, letterRendering: true },
        //   html2canvas: { dpi: 300, scale: 2 },
        //   jsPDF: { unit: "cm", format: "a4", orientation: "portrait" },
        // }).then((response) => {
        //   this.isLoading = false;
        // });

        html2pdf(null, {
          margin: 1,
          // filename: item.number + ".pdf",
          image: { type: "jpeg", quality: 0.98 },
          html2canvas: { dpi: 300, scale: 2 },
          jsPDF: { unit: "cm", format: "a4", orientation: "landscape" },
          // pagebreak: {
          //     mode: ['avoid-all', 'css', 'legacy']
          // }
          pagebreak: { avoid: ["tr", "td"], before: "#nextpage1" },
        })
          .from(elementToPrint)
          .toPdf()
          .get("pdf")
          .then(function (pdf) {
            var totalPages = pdf.internal.getNumberOfPages();
            var i;

            for (i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              pdf.setFontSize(10);
              pdf.setTextColor(150);

              pdf.text(
                getDateTime(),
                0.9,
                pdf.internal.pageSize.getHeight() - 0.5
              );

              pdf.text(
                i + " od " + totalPages,
                pdf.internal.pageSize.getWidth() / 1.075,
                pdf.internal.pageSize.getHeight() - 0.5
              );
            }
            _this.isLoading = false;

            window.open(pdf.output("bloburl"), "_blank");
          });
      }, 10);
    },
    getAllVina() {
      this.isLoading = true;

      this.naziv_fajla = "vino_u_tankovima.xls";

      this.json_fields = {
        Rb: "String",
        Datum: "Date",
        Operacija: "String",
        "Iz tanka": "String",
        "U tank": "String",
        Vino: "String",
        Faza: "String",
        "Dodatak/Parametar": "String",
        Količina: "String",
      };

      this.json_fields_type = [
        "String",
        "Date",
        "String",
        "String",
        "String",
        "String",
        "String",
        "String",
        "StringRight",
      ];

      let _this = this;

      let urlLoc =
        "/wine/tank_phase_wine/" +
        this.tpwId +
        "/history_flow?sortByTpwId=false";

      setTimeout(() => {
        this.$http
          .get(this.globalServiceLocation + this.globalPort + urlLoc, {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          })
          .then((response) => {
            this.items_states = response.data;

            let _this = this;
            this.json_data = [];

            response.data.forEach(function (entry) {
              let objekat = {
                Rb: entry.no,
                Datum: _this.formatDateTime(entry.date),
                Operacija:
                  entry.operation === "PRESSING" &&
                  entry.pressingFraction !== null
                    ? _this.prevediSveOperacijeLok(entry.operation) +
                      " - " +
                      entry.pressingFraction
                    : _this.prevediSveOperacijeLok(entry.operation),
                "Iz tanka": entry.tankFrom,
                "U tank": entry.tankTo,
                Vino: entry.wineAtMoment,
                // entry.operation === "CHANGE_WINE"
                //   ? entry.fromWine + " (" + (entry.fromWineInProduction ? 'u proizvodnji' : 'etiketa') + ") > " + entry.toWine + " (" + (entry.toWineInProduction ? 'u proizvodnji' : 'etiketa') + ")"
                //   : entry.wineAtMoment + (entry.wineAtMomentInProduction ? ' *' : ''),
                Faza: entry.phaseAtMoment,
                // entry.operation === "CHANGE_PHASE"
                //   ? entry.fromPhase + " > " + entry.toPhase
                //   : entry.phaseAtMoment,
                "Dodatak/Parametar":
                  entry.additiveParameter !== null
                    ? entry.additiveParameter
                    : "-",
                Količina: entry.quantity !== null ? entry.quantity + (entry.operation === "MACRO_OXYGENATION" || entry.operation === "MICRO_OXYGENATION" ? "(" + _this.formatDateTime(entry.date) + " - " + _this.formatDateTime(entry.oxygenationEndDate) + ")" : "") : "-",
              };
              _this.json_data.push(objekat);
            });

            this.isLoading = false;
          })
          .catch((e) => {
            if (!e.response) {
              this.isLoading = false;
              alert(
                this.$t("error.message")
              );
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    this.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          urlFinish,
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.items_states = response.data;

                        let _this = this;
                        this.json_data = [];

                        response.data.forEach(function (entry) {
                          let objekat = {
                            Rb: entry.no,
                            Datum: _this.formatDateTime(entry.date),
                            Operacija:
                              entry.operation === "PRESSING" &&
                              entry.pressingFraction !== null
                                ? _this.prevediSveOperacijeLok(
                                    entry.operation
                                  ) +
                                  " - " +
                                  entry.pressingFraction
                                : _this.prevediSveOperacijeLok(entry.operation),
                            "Iz tanka": entry.tankFrom,
                            "U tank": entry.tankTo,
                            Vino: entry.wineAtMoment,
                            // entry.operation === "CHANGE_WINE"
                            //   ? entry.fromWine + " (" + (entry.fromWineInProduction ? 'u proizvodnji' : 'etiketa') + ") > " + entry.toWine + " (" + (entry.toWineInProduction ? 'u proizvodnji' : 'etiketa') + ")"
                            //   : entry.wineAtMoment + (entry.wineAtMomentInProduction ? ' *' : ''),
                            Faza: entry.phaseAtMoment,
                            // entry.operation === "CHANGE_PHASE"
                            //   ? entry.fromPhase + " > " + entry.toPhase
                            //   : entry.phaseAtMoment,
                            "Dodatak/Parametar":
                              entry.additiveParameter !== null
                                ? entry.additiveParameter
                                : "-",
                                Količina: entry.quantity !== null ? entry.quantity + (entry.operation === "MACRO_OXYGENATION" || entry.operation === "MICRO_OXYGENATION" ? "(" + _this.formatDateTime(entry.date) + " - " + _this.formatDateTime(entry.oxygenationEndDate) + ")" : "") : "-",
                          };
                          _this.json_data.push(objekat);
                        });

                        this.isLoading = false;
                      });
                  });
              } else {
                this.isLoading = false;

                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
      }, 10);
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
  },
  mounted() {
    if(this.tpwId !== 0)
      this.getAllVina();
  },
};
</script>

<style scoped lang='scss'>
@import "./parts/../../assets/sass/parts/modalStyles_siri_modal";

div.layout.row.wrap {
  padding-top: 20px !important;
  max-height: 90px !important;
}

.topics tr {
  line-height: 14px;
}

.topics {
  margin-left: 10%;
  border-collapse: collapse;
  border-spacing: 0;
  width: 90%;
}

.topics th {
  height: 25px;
  font-weight: 500;
  font-size: 12px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  white-space: nowrap;
  color: rgba(0, 0, 0, 0.54);
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.topics td {
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

.menuable__content__active {
  background-color: white;
}
</style>